import Router from "@/router/index";
import Store from "@/store/index";

export default Router.afterEach(() => {
  if (Store.getters["size/viewType"] === "mobile" || Store.getters["size/viewType"] === "tablet") {
    Store.dispatch("menu/asideMobileStateToggle", false).then(() => {});
  }
});
